module.exports = __webpack_public_path__ + "static/media/Lens-Vivid Style.b6e7ce9e.png";